/** Figma `Divider` 세트(Components, 32:346) */
export const DIVIDER_ORIENTATIONS = ['horizontal', 'vertical'] as const;
export type DividerOrientation = (typeof DIVIDER_ORIENTATIONS)[number];

export const DIVIDER_TONES = ['subtle', 'default'] as const;
export type DividerTone = (typeof DIVIDER_TONES)[number];

/** 가로선은 부모 너비를, 세로선은 (flex 부모의) 높이를 채운다 */
export const DIVIDER_ORIENTATION_CLASS: Record<DividerOrientation, string> = {
  horizontal: 'h-px w-full',
  vertical: 'w-px self-stretch',
};

export const DIVIDER_TONE_CLASS: Record<DividerTone, string> = {
  subtle: 'bg-border-subtle',
  default: 'bg-border-default',
};
